<template>
  <div id="modalNovoProduto">
    <q-dialog v-model="OpenDialogNovoProduto" persistent>
      <q-card :class="{ minwidth: isNewProduto, maxwidth: !isNewProduto }">
        <q-card-section class="row items-center">
          <div class="text-h6">
            {{ isNewProduto ? "Novo " : "Editar " }} Produto
          </div>
          <q-space />
          <q-btn
            icon="close"
            flat
            round
            dense
            v-close-popup
            @click="closeModal()"
          />
        </q-card-section>
        <q-separator />
        <div class="row">
          <q-card-section
            :class="{
              'col-12 col-md-12 col-sm-12': isNewProduto,
              'col-md-6 col-sm-12': !isNewProduto
            }"
          >
            <div class="q-pa-md">
              <div class="q-col-gutter-md row">
                <div class="col-12 col-md-12">
                  <q-input
                    v-model="produtoCopy.nome"
                    label="Nome"
                    bottom-slots
                    :error="errorsProdutos.nome ? true : false"
                  >
                    <template v-slot:error>
                      <span
                        v-for="(error, i) in errorsProdutos.nome"
                        :key="error + i"
                        >{{ error }}</span
                      >
                    </template>
                  </q-input>
                </div>
                <div class="col-12 col-md-12">
                  <q-select
                    clearable
                    v-model="produtoCopy.categoria_id"
                    :options="categorias"
                    option-value="id"
                    option-label="titulo"
                    emit-value
                    map-options
                    label="Categoria"
                    bottom-slots
                    :error="errorsProdutos.categoria_id ? true : false"
                  >
                    <template v-slot:error>
                      <span
                        v-for="(error, i) in errorsProdutos.categoria_id"
                        :key="error + i"
                        >{{ error }}</span
                      >
                    </template>
                    <template v-slot:no-option>
                      <q-item>
                        <q-item-section class="text-grey"
                          >Sem Resultados</q-item-section
                        >
                      </q-item>
                    </template>
                  </q-select>
                </div>
                <div class="col-12 col-md-12">
                  <q-select
                    v-model="produtoCopy.tiposoma"
                    :options="tiposSomaProdutos"
                    option-value="value"
                    option-label="name"
                    emit-value
                    map-options
                    label="Tipo Soma"
                    bottom-slots
                    :error="errorsProdutos.tiposoma ? true : false"
                  >
                    <template v-slot:error>
                      <span
                        v-for="(error, i) in errorsProdutos.tiposoma"
                        :key="error + i"
                        >{{ error }}</span
                      >
                    </template>
                  </q-select>
                </div>
                <div class="col-12 col-md-6">
                  <q-field
                    v-model="produtoCopy.vlrcomissao"
                    label="Comissão da Lotérica"
                    bottom-slots
                    :error="errorsProdutos.vlrcomissao ? true : false"
                  >
                    <template v-slot:before>
                      <q-btn
                        :label="setarTpComissao"
                        size="md"
                        @click="printTpComissao"
                      />
                    </template>
                    <template
                      v-slot:control="{ id, floatingLabel, modelValue, emitValue }"
                    >
                      <money-input
                        :id="id"
                        class="q-field__native text-right"
                        :value="modelValue"
                        @input="emitValue"
                        v-bind="
                          produtoCopy.tpcomissao === '%'
                            ? percentFormat
                            : moneyFormat
                        "
                        v-show="floatingLabel"
                      >
                      </money-input>
                    </template>
                    <template v-slot:error>
                      <span
                        v-for="(error, i) in errorsProdutos.vlrcomissao"
                        :key="error + i"
                        >{{ error }}</span
                      >
                    </template>
                  </q-field>
                </div>

                <div class="col-12 col-md-6">
                  <q-field
                    v-model="produtoCopy.vlrcomissao_func"
                    label="Comissão para o Vendedor"
                    bottom-slots
                    :error="errorsProdutos.vlrcomissao_func ? true : false"
                  >
                    <template v-slot:before>
                      <q-btn
                        :label="setarTpComissaoFunc"
                        size="md"
                        @click="printTpComissaoFunc"
                        small
                      />
                    </template>
                    <template
                      v-slot:control="{ id, floatingLabel, modelValue, emitValue }"
                    >
                      <money-input
                        :id="id"
                        class="q-field__native text-right"
                        :value="modelValue"
                        @input="emitValue"
                        v-bind="
                          produtoCopy.tpcomissao_func === '%'
                            ? percentFormat
                            : moneyFormat
                        "
                        v-show="floatingLabel"
                      >
                      </money-input>
                    </template>
                    <template v-slot:error>
                      <span
                        v-for="(error, i) in errorsProdutos.vlrcomissao_func"
                        :key="error + i"
                        >{{ error }}</span
                      >
                    </template>
                  </q-field>
                </div>
                <div class="col-12">
                  <q-select
                    label="Tipo controle"
                    :options="tipoControle"
                    v-model="produtoCopy.tpcontrole"
                    :error="errorsProdutos.tpcontrole ? true : false"
                  >
                   <template v-slot:error>
                      <span
                        v-for="(error, i) in errorsProdutos.tpcontrole"
                        :key="error + i"
                        >{{ error }}</span
                      >
                    </template>
                  </q-select>
                </div>
                <div class="col-6 col-md-6">
                  <q-input
                    v-model="produtoCopy.ordem"
                    mask="##"
                    bottom-slots
                    :error="errorsProdutos.ordem ? true : false"
                    label="Ordem"
                  >
                    <template v-slot:error>
                      <span
                        v-for="(error, i) in errorsProdutos.ordem"
                        :key="error + i"
                        >{{ error }}</span
                      >
                    </template>
                  </q-input>
                </div>
                <div class="col-6 col-md-6">
                  <q-field
                    v-model="produtoCopy.vlrcusto"
                    label="Custo"
                    bottom-slots
                    :error="errorsProdutos.vlrcusto ? true : false"
                  >
                    <template
                      v-slot:control="{ id, floatingLabel, modelValue, emitValue }"
                    >
                      <money-input
                        :id="id"
                        class="q-field__native text-right"
                        :value="modelValue"
                        @input="emitValue"
                        v-bind="moneyFormat"
                        v-show="floatingLabel"
                      >
                      </money-input>
                    </template>
                    <template v-slot:error>
                      <span
                        v-for="(error, i) in errorsProdutos.vlrcusto"
                        :key="error + i"
                        >{{ error }}</span
                      >
                    </template>
                  </q-field>
                </div>
                <div class="col-6 col-md-6">
                  <q-field
                    v-model="produtoCopy.vlrvenda"
                    label="Venda"
                    bottom-slots
                    :error="errorsProdutos.vlrvenda ? true : false"
                  >
                    <template
                      v-slot:control="{ id, floatingLabel, modelValue, emitValue }"
                    >
                      <money-input
                        :id="id"
                        class="q-field__native text-right"
                        :value="modelValue"
                        @input="emitValue"
                        v-bind="moneyFormat"
                        v-show="floatingLabel"
                      >
                      </money-input>
                    </template>
                    <template v-slot:error>
                      <span
                        v-for="(error, i) in errorsProdutos.vlrvenda"
                        :key="error + i"
                        >{{ error }}</span
                      >
                    </template>
                  </q-field>
                </div>
                <div class="col-6 col-md-6" v-if="!isNewProduto">
                  <q-input
                    v-model="produtoCopy.text_detect"
                    bottom-slots
                    :error="errorsProdutos.text_detect ? true : false"
                    label="Detecção na Foto"
                  >
                    <template v-slot:error>
                      <span
                        v-for="(error, i) in errorsProdutos.text_detect"
                        :key="error + i"
                        >{{ error }}</span
                      >
                    </template>
                  </q-input>
                </div>
                <div class="col-6 col-md-6" v-if="!isNewProduto">
                  <q-input
                    v-model="produtoCopy.text_detect_pdf"
                    bottom-slots
                    :error="errorsProdutos.text_detect_pdf ? true : false"
                    label="Detecção no PDF"
                  >
                    <template v-slot:error>
                      <span
                        v-for="(error, i) in errorsProdutos.text_detect_pdf"
                        :key="error + i"
                        >{{ error }}</span
                      >
                    </template>
                  </q-input>
                </div>
                <div class="col-6 col-md-6" v-if="!isNewProduto">
                  <q-field
                    v-model="produtoCopy.similaridade"
                    label="Similaridade (de 70% a 95%)"
                    bottom-slots
                    :error="Boolean(errorsProdutos.similaridade)"
                  >
                    <template
                      v-slot:control="{ id, floatingLabel, modelValue, emitValue }"
                    >
                      <money-input
                        :id="id"
                        class="q-field__native text-right"
                        :value="modelValue"
                        @input="emitValue"
                        v-bind="percentFormat"
                        v-show="floatingLabel"
                      >
                      </money-input>
                    </template>
                    <template v-slot:error>
                      <span
                        v-for="(error, i) in errorsProdutos.similaridade"
                        :key="error + i"
                        >{{ error }}</span
                      >
                    </template>
                  </q-field>
                </div>
                <div class="col-12">
                  <q-checkbox
                    v-model="produtoCopy.ativo"
                    label="Ativo"
                    color="green"
                  />
                  <q-checkbox
                    v-model="produtoCopy.ocultar_venda"
                    label="Ocultar na Venda"
                    color="green"
                    class="q-ml-sm"
                  />
                </div>
                <div class="col-12">
                  <q-select
                    use-input
                    v-model="planodeconta"
                    option-label="titulo"
                    option-value="id"
                    :options="planoContasFilterResult"
                    label="Plano de Conta"
                    clearable
                    @filter="planoContasFilter"
                  >
                    <template v-slot:no-option>
                      <q-item>
                        <q-item-section class="text-grey">Sem Resultados</q-item-section>
                      </q-item>
                    </template>
                  </q-select>
                </div>
              </div>
            </div>
          </q-card-section>
          <q-card-section class="col-md-6 col-sm-12" v-if="!isNewProduto">
            <div class="q-pa-sm">
              <div class="row q-col-gutter-md">
                <div
                  class="col-12 col-md-12"
                  style="position:relative;left: -25px"
                >
                  <q-btn
                    v-ripple
                    label="Nova Regra"
                    icon="add"
                    dense
                    class="q-ml-sm q-px-md bg-positive text-white"
                    style="margin-bottom: 15px; margin-top: 15px;"
                    clickable
                    @click="modalRegra()"
                  />
                </div>
                <q-list
                  bordered
                  class="rounded-borders"
                  style="padding: 0px !important"
                >
                  <q-item-label header>Regras</q-item-label>
                  <div
                    v-for="(regra, i) in produtoCopy.prodregras"
                    :key="regra.nomenclatura + i"
                  >
                    <q-item>
                      <q-item-section top>
                        <q-item-label lines="1" class="title-regra">
                          <span class="text-weight-medium">{{ regra.nomenclatura }}</span>
                          <span class="text-grey-8">&nbsp;-&nbsp;{{ regra.tipo }}</span>
                        </q-item-label>
                        <q-item-label caption lines="1" style="text-wrap: wrap;">
                          <strong>{{ regra.valor }}</strong>&nbsp;
                          <strong>{{ regra.tpvalor }}</strong>&nbsp;
                          <strong>{{ regra.quando }}</strong>&nbsp;em&nbsp;
                          <strong>{{ regra.dias }}</strong>&nbsp;dia(s)&nbsp;do&nbsp;tipo&nbsp;
                          <strong>{{ regra.tipo }}</strong>,&nbsp;da nomenclatura&nbsp;
                          <strong>{{ regra.nomenclatura }}</strong>&nbsp;e&nbsp;conta&nbsp;bancária&nbsp;
                          <strong>{{ getContaNome(regra.conta_id) }}</strong>.
                        </q-item-label>
                        <q-item-label v-if="usaPlano(regra.quando)" caption lines="1">
                          Plano de contas:&nbsp;<strong>{{ getPlanoRegraNome(regra.planodeconta_id) }}</strong>
                        </q-item-label>
                      </q-item-section>

                      <q-item-section top side style="padding-left: 0;">
                        <div class="text-grey-8 q-gutter-xs">
                          <q-btn
                            clickable
                            @click="deleteRegra(regra, i)"
                            size="12px"
                            flat
                            dense
                            round
                            icon="delete"
                          />
                          <q-btn
                            clickable
                            @click="modalRegra(regra)"
                            size="12px"
                            flat
                            dense
                            round
                            icon="edit"
                          />
                        </div>
                      </q-item-section>
                    </q-item>
                    <q-separator
                      spaced
                      v-if="
                        produtoCopy && produtoCopy.prodregras.length - i > 1
                      "
                    />
                  </div>
                </q-list>
              </div>
            </div>
          </q-card-section>
          <q-card-section class="col-12 q-mt-md">
            <q-btn
              no-wrap
              v-ripple
              label="Salvar"
              no-caps
              class="q-ml-sm q-px-md bg-positive text-white absolute-bottom-right"
              style="margin: 0 30px 20px 0"
              clickable
              :loading="saveProduto"
              @click="addProduto()"
            >
              <template v-slot:loading>
                <q-spinner color="grey-10" size="1em" />
              </template>
            </q-btn>
          </q-card-section>
        </div>
      </q-card>
    </q-dialog>
    <q-dialog v-model="OpenDialogNovaRegraProduto" persistent>
      <q-card style="width: 400px !important">
        <q-card-section class="row items-center">
          <div class="text-h6">Nova Regra Produto</div>
          <q-space />
          <q-btn
            icon="close"
            flat
            round
            dense
            v-close-popup
            @click="closeModalR()"
          />
        </q-card-section>
        <q-separator />
        <q-card-section>
          <div class="q-pa-md">
            <div class="q-col-gutter-md row">
              <div class="col-12 col-md-12">
                <q-input
                  v-model="regraProduto.nomenclatura"
                  label="Nomenclatura"
                  bottom-slots
                  :error="errorsRegras.nomenclatura ? true : false"
                >
                  <template v-slot:error>
                    <span
                      v-for="(error, i) in errorsRegras.nomenclatura"
                      :key="error + i"
                      >{{ error }}</span
                    >
                  </template>
                </q-input>
              </div>
              <div class="col-12 col-md-12">
                <q-select
                  v-model="regraProduto.tpnomenclatura"
                  :options="tpnomenclaturaProdutos"
                  option-label="name"
                  option-value="value"
                  emit-value
                  map-options
                  label="Tipo de Nomenclatura"
                  @update:model-value="regraProduto.planodeconta_id = null"
                  bottom-slots
                  :error="errorsRegras.tpnomenclatura ? true : false"
                >
                  <template v-slot:error>
                    <span
                      v-for="(error, i) in errorsRegras.tpnomenclatura"
                      :key="error + i"
                      >{{ error }}</span
                    >
                  </template>
                </q-select>
              </div>
              <div class="col-12 col-md-12">
                <q-select
                  clearable
                  v-model="regraProduto.tipo"
                  :options="tipoRegrasProdutos"
                  label="Tipo"
                  bottom-slots
                  :error="errorsRegras.tipo ? true : false"
                >
                  <template v-slot:error>
                    <span
                      v-for="(error, i) in errorsRegras.tipo"
                      :key="error + i"
                      >{{ error }}</span
                    >
                  </template>
                  <template v-slot:no-option>
                    <q-item>
                      <q-item-section class="text-grey"
                        >Sem Resultados</q-item-section
                      >
                    </q-item>
                  </template>
                </q-select>
              </div>
              <div class="col-12 col-md-12">
                <q-select
                  clearable
                  v-model="regraProduto.conta_id"
                  :options="contas"
                  option-label="titulo"
                  option-value="id"
                  map-options
                  emit-value
                  label="Conta Bancária"
                  bottom-slots
                  :error="errorsRegras.conta_id ? true : false"
                >
                  <template v-slot:error>
                    <span
                      v-for="(error, i) in errorsRegras.conta_id"
                      :key="error + i"
                      >{{ error }}</span
                    >
                  </template>
                  <template v-slot:no-option>
                    <q-item>
                      <q-item-section class="text-grey"
                        >Sem Resultados</q-item-section
                      >
                    </q-item>
                  </template>
                </q-select>
              </div>
              <div class="col-12 col-md-12">
                <q-select
                  clearable
                  v-model="regraProduto.quando"
                  :options="tipoRegrasAcontarProdutos"
                  label="A Contar"
                  @update:model-value="limparPlanoSemUso"
                  bottom-slots
                  :error="errorsRegras.quando ? true : false"
                >
                  <template v-slot:error>
                    <span
                      v-for="(error, i) in errorsRegras.quando"
                      :key="error + i"
                      >{{ error }}</span
                    >
                  </template>
                  <template v-slot:no-option>
                    <q-item>
                      <q-item-section class="text-grey"
                        >Sem Resultados</q-item-section
                      >
                    </q-item>
                  </template>
                </q-select>
              </div>
              <div v-if="regraUsaPlano" class="col-12 col-md-12">
                <q-select
                  clearable
                  use-input
                  v-model="regraProduto.planodeconta_id"
                  :options="planosRegraFiltrados"
                  option-label="titulo"
                  option-value="id"
                  option-disable="disable"
                  map-options
                  emit-value
                  label="Plano de Contas"
                  hint="Plano de contas do lançamento gerado pela regra"
                  bottom-slots
                  :loading="loadingPlanosRegra"
                  :error="errorsRegras.planodeconta_id ? true : false"
                  @filter="planosRegraFilter"
                >
                  <template v-slot:error>
                    <span
                      v-for="(error, i) in errorsRegras.planodeconta_id"
                      :key="error + i"
                      >{{ error }}</span
                    >
                  </template>
                  <template v-slot:no-option>
                    <q-item>
                      <q-item-section class="text-grey"
                        >Sem Resultados</q-item-section
                      >
                    </q-item>
                  </template>
                </q-select>
              </div>
              <div class="col-12 col-md-12">
                <q-select
                  clearable
                  v-model="regraProduto.tpvalor"
                  :options="tipoRegrasValorProdutos"
                  label="Tipo Valor"
                  bottom-slots
                  :error="errorsRegras.tpvalor ? true : false"
                >
                  <template v-slot:error>
                    <span
                      v-for="(error, i) in errorsRegras.tpvalor"
                      :key="error + i"
                      >{{ error }}</span
                    >
                  </template>
                  <template v-slot:no-option>
                    <q-item>
                      <q-item-section class="text-grey"
                        >Sem Resultados</q-item-section
                      >
                    </q-item>
                  </template>
                </q-select>
              </div>
              <div class="col-6 col-md-6">
                <q-input
                  v-model="regraProduto.dias"
                  bottom-slots
                  :error="errorsRegras.dias ? true : false"
                  mask="###"
                  label="Dias"
                >
                  <template v-slot:error>
                    <span
                      v-for="(error, i) in errorsRegras.dias"
                      :key="error + i"
                      >{{ error }}</span
                    >
                  </template>
                </q-input>
              </div>
              <div class="col-6 col-md-6">
                <q-field
                  v-model="regraProduto.valor"
                  label="Custo"
                  bottom-slots
                  :error="errorsRegras.valor ? true : false"
                >
                  <template
                    v-slot:control="{ id, floatingLabel, modelValue, emitValue }"
                  >
                    <money-input
                      :id="id"
                      class="q-field__native text-right"
                      :value="modelValue"
                      @input="emitValue"
                      v-bind="
                        regraProduto.tpvalor === '%' ||
                        regraProduto.tpvalor === '% Restante'
                          ? percentFormat
                          : moneyFormat
                      "
                      v-show="floatingLabel"
                    >
                    </money-input>
                  </template>
                  <template v-slot:error>
                    <span
                      v-for="(error, i) in errorsRegras.valor"
                      :key="error + i"
                      >{{ error }}</span
                    >
                  </template>
                </q-field>
              </div>
              <div class="col-12 col-md-12 q-p-lg">
                <q-btn
                  no-wrap
                  v-ripple
                  label="Adicionar Regra"
                  no-caps
                  class="q-ml-sm q-px-md bg-positive text-white absolute-bottom-right"
                  style="margin: 0 30px 20px 0"
                  clickable
                  :loading="saveRegra"
                  @click="addRegra()"
                >
                  <template v-slot:loading>
                    <q-spinner color="grey-10" size="1em" />
                  </template>
                </q-btn>
              </div>
            </div>
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import MoneyInput from "@/components/Utils/money-input.vue";
import axios from "@/axios-auth";
export default {
  name: "modal-novo-produto",
  components: { MoneyInput },
  data() {
    return {
      produtoCopy: this.newProduto(),
      regraProduto: this.newRegraProduto(),
      moneyFormat: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2,
        masked: false
      },
      percentFormat: {
        decimal: ".",
        thousands: "",
        prefix: "",
        suffix: " %",
        precision: 2,
        masked: false
      },
      planodeconta: null,
      planoContasFilterResult: [],
      planosRegra: [],
      planosRegraFiltrados: [],
      loadingPlanosRegra: false,
      tipoControle: ["Nenhum", "Extração", "Concurso", "Evento"]
    };
  },
  watch: {
    planosRegraDoTipo: {
      // map-options only shows the plan name when the selected plan is among the options.
      handler(value) {
        this.planosRegraFiltrados = value;
      },
      immediate: true
    },
    produto(value) {
      if (this.isNewProduto) {
        this.produtoCopy = this.newProduto();
      } else {
        this.produtoCopy = JSON.parse(JSON.stringify(value));

        if (!this.planodeconta) {
          this.planodeconta = value.planodeconta ? value.planodeconta : null;
        }

        this.planodeconta = value.planodeconta ? value.planodeconta : null;
        this.$store.dispatch("planoContas");
        this.loadPlanosRegra();
      }
    }
  },
  methods: {
    printTpComissao() {
      this.produtoCopy.tpcomissao =
        this.produtoCopy.tpcomissao === "$" ? "%" : "$";
    },
    printTpComissaoFunc() {
      this.produtoCopy.tpcomissao_func =
        this.produtoCopy.tpcomissao_func === "$" ? "%" : "$";
    },
    newProduto() {
      return {
        id: null,
        ativo: true,
        tipo: "P",
        nome: "",
        categoria_id: null,
        vlrcusto: 0.0,
        vlrvenda: 0.0,
        vlrlucro: 0.0,
        vlrcomissao: 0.0,
        tpcontrole: "Nenhum",
        ordem: 1,
        planodeconta_id: null,
        text_detect: "",
        text_detect_pdf: "",
        similaridade: 0.00,
        tiposoma: null,
        tpcomissao: "$",
        vlrcomissao_func: 0.0,
        tpcomissao_func: "$",
        produto_id: null,
        prodregras: [],
        ocultar_venda: false
      };
    },
    newRegraProduto() {
      return {
        id: null,
        tipo: "",
        conta_id: null,
        quando: "",
        dias: 0,
        tpvalor: "",
        valor: "",
        nomenclatura: "",
        tpnomenclatura: "C",
        planodeconta_id: null
      };
    },
    closeModalR() {
      this.regraProduto = this.newRegraProduto();
      this.$store.commit("OpenDialogNovaRegraProduto", false);
      this.$store.commit("errorsProdutos", []);
      this.$store.commit("addRegraProdutos", this.regraProduto);
    },
    closeModal() {
      this.produtoCopy = this.newProduto();
      this.$store.commit("produto", this.produtoCopy);
      this.$store.commit("isNewProduto", true);
      this.$store.commit("OpenDialogNovoProduto", false);
      this.$store.commit("errorsProdutos",[]);
    },
    addProduto() {
      this.produtoCopy.planodeconta_id = this.planodeconta ? this.planodeconta.id : null;
      this.produtoCopy.ordem = this.produtoCopy.ordem !== null && this.produtoCopy.ordem !== ""
        ? this.produtoCopy.ordem : this.produtosProdutos.length;

      this.produtoCopy.tipo = "P";
      this.$store.dispatch("addProduto", this.produtoCopy);
    },
    deleteRegra(regra, i) {
      let data = {
        produto: this.produtoCopy,
        regra: regra,
        pos: i
      };

      this.$store.dispatch("deleteRegraProduto", data);
    },
    usaPlano(quando) {
      // Only the "Da Compra" rules carry the plano to the lançamento (finalizarCompra).
      return !!quando && quando.indexOf("Da Compra") > -1;
    },
    limparPlanoSemUso(quando) {
      if (!this.usaPlano(quando)) {
        this.regraProduto.planodeconta_id = null;
      }
    },
    modalRegra(regra) {
      this.loadPlanosRegra();
      this.$store.dispatch("errorsProdutos", []);
      if (regra) {
        this.regraProduto = JSON.parse(JSON.stringify(regra));
        this.$store.dispatch("modalRegraProduto", this.regraProduto);
      } else {
        this.$store.dispatch("modalRegraProduto");
      }
      // A filter typed in the previous rule would hide this rule's plano from the options.
      this.planosRegraFiltrados = this.planosRegraDoTipo;
    },
    addRegra() {
      if (this.isNewRegraProduto) {
        this.regraProduto.produto_id = this.produto.id;
      }
      this.$store.dispatch("addRegraProduto", this.regraProduto).then(res => {
        if (res.success) {
          this.regraProduto = this.newRegraProduto();
        }
      });
    },
    getContaNome(value) {
      if (!value) {
        return "Sem conta cadastrada";
      }
      for (let i = 0; i < this.contas.length; i++) {
        if (this.contas[i].id === value) {
          return this.contas[i].titulo;
        }
      }
      return "Sem conta cadastrada";
    },
    loadPlanosRegra() {
      if (this.planosRegra.length || this.loadingPlanosRegra) {
        return;
      }

      // All analytic plans: the rule list shows names of both types, and the select filters by the rule type.
      this.loadingPlanosRegra = true;
      axios
        .get("/plano-contas", { params: { cd: "" } })
        .then(res => {
          if (res.data.success) {
            this.planosRegra = res.data.planodecontas;
          }
        })
        .finally(() => {
          this.loadingPlanosRegra = false;
        });
    },
    getPlanoRegraNome(id) {
      if (!id) {
        return "Não informado";
      }

      const plano = this.planosRegra.find(p => p.id === id);

      return plano ? plano.titulo : "Não informado";
    },
    planosRegraFilter(val, update) {
      update(() => {
        this.planosRegraFiltrados = this.planosRegraDoTipo.filter(
          plano => plano.titulo.toLowerCase().indexOf(val.toLowerCase()) > -1
        );
      });
    },
    planoContasFilter(val, update) {
      update(() => {
        this.planoContasFilterResult = this.planoContas.filter(
          plano => plano.titulo.toLowerCase().indexOf(val.toLowerCase()) > -1
        );
      });
    },
  },
  computed: {
    setarTpComissao:{
     get(){
       return this.produtoCopy.tpcomissao === "$" ? "R$" : "%";
     },
     set(){}
    },
    setarTpComissaoFunc:{
     get(){
       return this.produtoCopy.tpcomissao_func === "$" ? "R$" : "%";
     },
     set(){}
    },
    OpenDialogNovoProduto: {
      get() {
        return this.$store.getters.OpenDialogNovoProduto;
      },
      set() {}
    },
    OpenDialogNovaRegraProduto: {
      get() {
        return this.$store.getters.OpenDialogNovaRegraProduto;
      },
      set() {}
    },
    ...mapGetters([
      "produto",
      "isNewProduto",
      "categorias",
      "saveProduto",
      "errorsProdutos",
      "tipoValorProdutos",
      "tiposProdutos",
      "contas",
      "saveRegra",
      "addRegraProdutos",
      "produtosProdutos",
      "tiposSomaProdutos",
      "tipoControleProdutos",
      "isNewRegraProduto",
      "tpcomissaoProdutos",
      "tpcomissaofuncProdutos",
      "tpnomenclaturaProdutos",
      "tipoRegrasProdutos",
      "tipoRegrasValorProdutos",
      "tipoRegrasAcontarProdutos",
      "planoContas",
    ]),
    regraUsaPlano() {
      return this.usaPlano(this.regraProduto.quando);
    },
    planosRegraDoTipo() {
      // Débito also accepts "Nulo" plans, the same rule the expense screen uses.
      const tipos = this.regraProduto.tpnomenclatura === "D" ? ["D", "N"] : ["C"];

      return this.planosRegra.filter(plano => tipos.includes(plano.tipocd));
    },
    errorsRegras() {
      return this.errorsProdutos["prodregras"]
        ? this.errorsProdutos["prodregras"][0]
        : [];
    }
  }
};
</script>

<style lang="stylus" scoped>
.minwidth {
  width: 100%;
  @media (min-width: 1024px) {
    width: 600px;
  }
}

.maxwidth {
  width: 100%;
  @media (min-width: 1024px) {
    min-width: 800px;
    max-width: 1200px;
  }
}
</style>
